import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=5bd485da&scoped=true&"
import script from "./HeatMap.vue?vue&type=script&lang=ts&"
export * from "./HeatMap.vue?vue&type=script&lang=ts&"
import style0 from "./HeatMap.vue?vue&type=style&index=0&id=5bd485da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd485da",
  null
  
)

export default component.exports